import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from "@mui/material"
import { KeyboardArrowDownOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

import type { PriceChangeRecipient } from "@/graphql/codegen/graphql"
import ViewRecipientsTable from "@/screens/Pricing/components/tables/ViewRecipientsTable"

interface ReSendDialogTitleProps {
  recipients?: PriceChangeRecipient[]
  isFetching?: boolean
}

const ViewRecipientAccordion: FC<ReSendDialogTitleProps> = ({ recipients, isFetching }) => {
  return (
    <Box className='my-10'>
      <Accordion>
        <AccordionSummary
          expandIcon={<KeyboardArrowDownOutlined />}
          aria-controls='view-recipients-content'
          id='view-recipients-header'
        >
          <Typography component='span' className='text-sm font-normal'>
            View Recipients
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <ViewRecipientsTable data={recipients} isLoading={isFetching} />
        </AccordionDetails>
      </Accordion>
    </Box>
  )
}

export default ViewRecipientAccordion
